import { useVoucherGallery } from "../hooks/useVoucherGallery";
import { VoucherContainer } from "../VoucherContainer/VoucherContainer";

export interface VoucherPageProps {
  title?: string;
}

export function VoucherPage({ title }: VoucherPageProps) {
  const { vouchersGallery } = useVoucherGallery();
  return <VoucherContainer />;
}
